
import React, { useState, useContext, useEffect } from "react";

import * as XLSX from 'xlsx';

import {
  Card, CardBody, CardTitle, Col, Container, Button, Nav, Table,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Dropdown, UncontrolledAlert
} from "reactstrap";


import Variables from "../lib/variables/variables.js";
import Format from '../lib/format.js';
import ProgressBar from 'react-bootstrap/ProgressBar';
import CollapsibleAlert from "./components/CollapsibleAlert.js";

//###############################################################################################################

const MoondanceLayout = {

  number_format: 'fr-FR',
  is_dark_mode: false,
  userCurrency: 'EUR',


  //###############################################################################################################
  //backward compatibility with funcitions moved to format.js
  formatDate: Format.formatDate,
  formatCurrency: Format.formatCurrency,
  formatPercentage: Format.formatPercentage,
  formatNumber: Format.formatNumber,
  capitalizeFirstLetter: Format.capitalizeFirstLetter,
  formatDate_DMY_to_YMD: Format.formatDate_DMY_to_YMD,
  formatValue: Format.formatValue,
  customSelectPattern: Format.customSelectPattern,
  select2customStyles: Format.select2customStyles,
  findMaxMin: Format.findMaxMin,


  //###############################################################################################################
  //backward compatibility with  variables moved to variables.js
  statusList: Variables.statusList,
  currencyList: Variables.currencyList,
  sectorList: Variables.sectorList,
  geographyList: Variables.geographyList,
  assetType: Variables.assetType,
  transactionType: Variables.transactionType,
  dark_colorScheme: Variables.dark_colorScheme,
  light_colorScheme: Variables.light_colorScheme,
  colorScheme: Variables.colorScheme,
  printColorScheme: Variables.printColorScheme,
  //###############################################################################################################

  getGeographyList() {

    this.geographyList.sort(function (a, b) {
      var labelA = a.label.toUpperCase();
      var labelB = b.label.toUpperCase();
      if (labelA < labelB) {
        return -1;
      }
      if (labelA > labelB) {
        return 1;
      }
      return 0;
    });
    return this.geographyList
  },



  displayArrayLabels(arrayOfitems) {
    if (!Array.isArray(arrayOfitems) || arrayOfitems.length === 0) {
      return 'No data'
    }
    let returnValue = '';
    arrayOfitems.forEach(item => {
      returnValue += item.label + ', ';
    });
    return returnValue.slice(0, -2);
  },

  switchDarkMode(value) {
    this.is_dark_mode = value;
    Variables.colorScheme = value ? this.dark_colorScheme : this.light_colorScheme;
    if (this.is_dark_mode) {
      localStorage.setItem("darkmode", true);
      document.body.style.backgroundColor = '#15171F';
      var rootElement = document.getElementById('root');
      if (rootElement) {
        rootElement.style.backgroundColor = '#15171F';
      }
    } else {

      localStorage.setItem("darkmode", false);
      document.body.style.backgroundColor = '#F3F3F4';
      rootElement = document.getElementById('root');
      if (rootElement) {
        rootElement.style.backgroundColor = '#F3F3F4';
      }

    }

  },
  currencyShort: {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
    'CAD': 'CAD',
    'NOK': 'NOK',
    'CHF': 'CHF'


  },





  testurl(needle, haystack) {
    const regex = new RegExp(needle);
    return regex.test(haystack);
  },

  // One line, expandable. The full-card version stacked between the tab bar and
  // the tab content, so a position raising three warnings pushed every figure off
  // the first screen. Signature unchanged, so call sites are untouched.
  alertBlock(title, body, type = "warning") {
    return <CollapsibleAlert title={title} body={body} type={type} />
  },


  currentYear() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return currentYear
  },
  buildAssetTypeSelectOptions() {

    const assetTypeArray = Object.keys(this.assetType).map((key) => {
      const { label, description } = this.assetType[key];
      return { value: key, label, description };
    });
    //console.log(assetTypeArray)
    return assetTypeArray

  },
  getTransactionTypeLabel(searchId) {
    var matchingRowthisTransactionType = MoondanceLayout.transactionType.find(item => item.value === searchId);
    if (matchingRowthisTransactionType) {
      return matchingRowthisTransactionType.label;
    } else {
      return searchId
    }
  },
  currencySymbol(currency) {
    if (this.currencyShort[currency]) {
      return this.currencyShort[currency]
    } else {
      return currency
    }

  },

  card(props) {

    return (

      <Col xl={(props.xlWidth ? props.xlWidth : 3)} sm={(props.smWidth ? props.smWidth : 3)} md={(props.mdWidth ? props.mdWidth : 4)} xs={(props.xsWidth ? props.xsWidth : 6)}>
        <Card className="equal-height-card " >

          {(props.cardBody ? <CardBody>{props.cardBody}</CardBody> :

            <>
              {(props.cardTitle ? <CardTitle>{props.cardTitle}</CardTitle> : '')}

              {((props.title || props.value || props.value_sub || props.textprops || props.subText) ?
                <div className="d-flex text-muted">
                  <div className="flex-grow-1 overflow-hidden">

                    {(props.title ? <p className="mb-1">{props.title}</p> : '')}
                    {(props.value ? <><p style={{ minWidth: '8em', fontWeight: 300, lineHeight: '3rem', fontSize: '1.8rem', marginBottom: '0' }}>{props.value}</p>
                      {(props.value_sub ?
                        <h6 style={{ marginTop: '0.3em' }} className="text-muted">{(props.value_sub ? props.value_sub : '')}</h6>
                        : ''
                      )}</>
                      : '')}
                    {(props.text ?
                      <p className="mb-0">{(props.text ? props.text : '')}<br /></p>
                      : '')}
                    {(props.subText ?
                      <p className=" mb-0">{(props.subText ? props.subText : '')}<br /></p>
                      : '')}

                  </div>
                </div> : '')}

            </>
          )}
        </Card>

      </Col>
    )

  },
  insideItem(props) {

    return (


      <Col xl={(props.xlWidth ? props.xlWidth : 3)} sm={(props.smWidth ? props.smWidth : 3)}>
        <div className="d-flex text-muted">
          <div className="flex-grow-1 overflow-hidden">

            {(props.title ? <p className="mb-1">{props.title}</p> : '')}
            {(props.value ? <>
              <h5 className="mb-3">{props.value}</h5> {(props.value_sub ?
                <h6 className="text-muted">{(props.value_sub ? props.value_sub : '')}</h6>
                : ''
              )}</> : '')}
            {(props.text ?
              <p className="mb-0">{(props.text ? props.text : '')}<br /></p>
              : '')}
            {(props.subText ?
              <p className=" mb-0">{(props.subText ? props.subText : '')}<br /></p>
              : '')}

          </div>
        </div>

      </Col >
    )

  },
  progressBar(props) {

    return (
      <div className="d-flex">
        {(props.icon ?
          <div className="avatar-xs align-self-center me-3">
            <div className="avatar-title rounded-circle bg-light  font-size-18">
              <span className={props.icon}></span>
            </div>
          </div>
          : '')}
        <div className="flex-grow-1">
          <Row>
            <Col xl={8}><p className="text-muted mb-2"><span>{props.title}</span></p></Col>
            <Col xl={4}><p className="text-muted mb-2 text-end"><span>{props.value} </span></p></Col>
          </Row>


          {(props.custom_progressBar ? <div>{props.custom_progressBar}</div> : '')}

          {(props.value_pct ?
            <div>
              <ProgressBar
                variant={(props.style ? props.style : "info")}
                min={(props.min ? props.min : 0)}
                max={(props.max ? props.max : 100)}
                now={parseInt(props.value_pct)}
                label={(props.label ? props.label : props.value_pct + "%")}
              />
            </div>
            : '')}
          <Row>
            <Col xl={8}><p className="text-muted mb-2" style={{ marginTop: "8px" }}><span>{(props.subText ? props.subText : '')}</span></p></Col>
            <Col xl={4}><p className="text-muted mb-2 text-end" style={{ marginTop: "8px" }}><span>{(props.value_sub ? props.value_sub : '')}</span></p></Col>
          </Row>

        </div>
      </div>

    )



  },
  buildValueCreationChart(data, cashflowChartDisplay) {
    //console.log('buildCashFlowChart', data)
    var returnData = {}
    returnData.rawdata = [];
    returnData.rawdata['eoy_nav'] = [];
    returnData.rawdata['cashFlows'] = [];
    returnData.rawdata['nav'] = [];
    returnData.rawdata['value_creation'] = [];
    returnData.categories = [];
    var budgetData = []
    //console.log('buildCashFlowChart', showBudget, data.budget)


    data.perYear.forEach((item, index) => {
      // A year with no valuation on either side has an UNKNOWN change in NAV, not a
      // zero one. Counting it as zero made the early years - before NAVs were
      // recorded at all - show the capital called as pure value destruction.
      const eoy = parseFloat(item.sum_end_of_year_nav_in_user_currency) || 0;
      const boy = parseFloat(item.sum_end_of_previous_year_nav_in_user_currency) || 0;
      const hasValuation = eoy !== 0 || boy !== 0;
      if (item.year > 0 && item.year <= new Date().getFullYear() && hasValuation) {
        //console.log('buildValueCreationChart', item)
        returnData.categories.push(item.year.toString())
        // Value creation = what the holdings gained + what actually moved in cash.
        //   sum_nav_increase_in_user_currency = SUM(eoy_nav - boy_nav)
        //   sum_real_balance_in_user_currency = SUM(calls) + SUM(distributions),
        //                                       calls being negative
        // so their sum is exactly "delta NAV + distributions - calls".
        const navDelta = parseFloat(item.sum_nav_increase_in_user_currency) || 0;
        const netCashFlow = parseFloat(item.sum_real_balance_in_user_currency) || 0;
        returnData.rawdata['cashFlows'].push(netCashFlow)
        returnData.rawdata['nav'].push(navDelta)
        returnData.rawdata['value_creation'].push(Math.round(navDelta + netCashFlow))
        returnData.rawdata['eoy_nav'].push(item.sum_end_of_year_nav_in_user_currency)
      } 
    });

    


returnData.data = []

let backgroundColors = []
let strokeWith = []
let strokeColors = []

 //   backgroundColors.push('transparent')
    //backgroundColors.push(Variables.colorScheme.info)
    //backgroundColors.push(Variables.colorScheme.success)
    // The two columns are stacked, so the height of each bar IS the value
    // creation of that year; the line repeats it as a single readable figure.
    // End-of-year NAV was dropped from here: the dashboard already carries a
    // chart dedicated to NAV over time, and it competed on a different scale.
    backgroundColors.push(Variables.colorScheme.success)
    backgroundColors.push(Variables.colorScheme.info)
    backgroundColors.push(Variables.colorScheme.dark)
    strokeColors = [Variables.colorScheme.success, Variables.colorScheme.info, Variables.colorScheme.dark]
    strokeWith = [0, 0, 3]


  returnData.data.push(

    {
      name: 'Variation of NAV',
      type: 'column',
      data: returnData.rawdata['nav'],
      color: Variables.colorScheme.success,
    },

    {
      name: 'Net cash flow (distributions - calls)',
      type: 'column',
      data: returnData.rawdata['cashFlows'],
      color: Variables.colorScheme.info,
    },

    {
      name: 'Value creation',
      type: 'line',
      data: returnData.rawdata['value_creation'],
      color: Variables.colorScheme.dark,
    })



returnData.options = {
  colors: backgroundColors

  ,
  xaxis: {
    type: 'category',
    categories: returnData.categories,
    convertedCatToNumeric: false,

  },
  markers: {
    size: 4,
    strokeWidth: 1,
    colors: Variables.colorScheme.dark
  },

  stroke: {
    curve: 'smooth',

    colors: strokeColors,
    width: strokeWith
  }
};

returnData.options.annotations = {
  yaxis: [
    {
      y: 0,
      borderColor: Variables.colorScheme.dark,
    }
  ],
 

};
//console.log('returnData annotations',showBudget, returnData.rawdata['b'],returnData.options.annotations)
// console.log('ValueCreation',returnData)
return returnData
  },
buildCashFlowChart(data, cashflowChartDisplay, showCapitalCallsOnly, showBudget = false, scale = "cash") {
  //console.log('buildCashFlowChart', data)
  var returnData = {}
  returnData.rawdata = [];
  returnData.rawdata['rcc'] = [];
  returnData.rawdata['rd'] = [];
  returnData.rawdata['b'] = [];
  returnData.rawdata['budget_cc'] = [];
  returnData.rawdata['budget_d'] = [];
  returnData.rawdata['budget_b'] = [];
  returnData.rawdata['mcc'] = [];
  returnData.rawdata['md'] = [];
  returnData.categories = [];
  var budgetData = []
  //console.log('buildCashFlowChart', showBudget, data.budget)

  if (showBudget && data.budget) {
    //console.log('buildCashFlowChart', data.budget)
    budgetData = MoondanceLayout.calculateBudget(data.budget)
  }

  //remove trailing empty values
  while (data.perYear.length > 0) {
    let lastItem = data.perYear[data.perYear.length - 1];
    if (lastItem.sum_real_capital_call_in_user_currency === 0 &&
      lastItem.sum_model_capital_call_in_user_currency === 0 &&
      lastItem.sum_model_distribution_in_user_currency === 0 &&
      lastItem.sum_real_distribution_in_user_currency === 0) {
      data.perYear.pop(); // Remove last item
    } else {
      break; // Break out of the loop once a non-zero item is found
    }
  }
  let coef = 1;
  if (scale === "pct_commited") {
    coef = 1 / data.summary.position_commitment_in_;
  }

  data.perYear.forEach((item, index) => {
    //console.log('buildCashFlowChart', item)
    let rcc = item.sum_real_capital_call_in_user_currency;
    let rd = item.sum_real_distribution_in_user_currency;
    let mcc = item.sum_model_capital_call_in_user_currency;
    let smd = item.sum_model_distribution_in_user_currency;
    let srcc = item.sum_remaining_capital_call_in_user_currency
    let srd = item.sum_remaining_distribution_in_user_currency

    if (scale === "cash_asset_currency") {

      rcc = item.sum_real_capital_call_in_asset_currency;
      rd = item.sum_real_distribution_in_asset_currency;
      mcc = item.sum_model_capital_call_in_asset_currency;
      smd = item.sum_model_distribution_in_asset_currency;
      srcc = item.sum_remaining_capital_call_in_asset_currency
      srd = item.sum_remaining_distribution_in_asset_currency

    } else if (scale === "pct_commited") {
      rcc = item.sum_real_capital_call_in_asset_currency / data.summary.position_commitment_in_asset_currency;
      rd = item.sum_real_distribution_in_asset_currency / data.summary.position_commitment_in_asset_currency;
      mcc = item.sum_model_capital_call_in_asset_currency / data.summary.position_commitment_in_asset_currency;
      smd = item.sum_model_distribution_in_asset_currency / data.summary.position_commitment_in_asset_currency;
      srcc = item.sum_remaining_capital_call_in_asset_currency / data.summary.position_commitment_in_asset_currency
      srd = item.sum_remaining_distribution_in_asset_currency / data.summary.position_commitment_in_asset_currency
    } else if (scale === "pct_called") {
      rcc = item.sum_real_capital_call_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency;
      rd = item.sum_real_distribution_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency;
      mcc = item.sum_model_capital_call_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency;
      smd = item.sum_model_distribution_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency;
      srcc = item.sum_remaining_capital_call_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency
      srd = item.sum_remaining_distribution_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency

    }

    if (item.year > 0 && item.year < new Date().getFullYear()) {

      if (cashflowChartDisplay !== 'Future') {
        returnData.categories.push(item.year.toString())
        returnData.rawdata['rcc'].push(rcc)
        returnData.rawdata['rd'].push(rd)
        returnData.rawdata['mcc'].push(0)
        returnData.rawdata['md'].push(0)
        returnData.rawdata['b'].push(rcc + rd)

        returnData.rawdata['budget_cc'].push(0)
        returnData.rawdata['budget_d'].push(0)

      }

    } else if (item.year > new Date().getFullYear()) {

      if (cashflowChartDisplay !== 'Past') {

        returnData.categories.push(item.year.toString())
        returnData.rawdata['rcc'].push(0)
        returnData.rawdata['rd'].push(0)

        returnData.rawdata['mcc'].push(mcc)
        returnData.rawdata['md'].push((smd > 0 ? smd : 0))
        returnData.rawdata['b'].push(mcc + smd)

        if (budgetData && budgetData.distributions && budgetData.distributions[item.year]) {
          returnData.rawdata['budget_d'].push(budgetData.distributions[item.year])
        } else {
          returnData.rawdata['budget_d'].push(0)
        }
        if (budgetData && budgetData.capitalCalls && budgetData.capitalCalls[item.year]) {
          returnData.rawdata['budget_cc'].push(-budgetData.capitalCalls[item.year])
        } else {
          returnData.rawdata['budget_cc'].push(0)
        }

      }
    } else if (item.year === new Date().getFullYear()) {

      returnData.categories.push(item.year.toString())
      if (cashflowChartDisplay === 'Future') {

        returnData.rawdata['rcc'].push(0)
        returnData.rawdata['rd'].push(0)

        returnData.rawdata['mcc'].push((mcc - rcc < 0 ? mcc - rcc : 0))
        returnData.rawdata['md'].push((smd - rd > 0 ? smd - rd : 0))
        returnData.rawdata['b'].push(
          (-mcc > -rcc ? mcc - rcc : 0)
          + (smd > rd ? smd - rd : 0)
        )
        if (budgetData && budgetData.distributions && budgetData.distributions[item.year]) {
          returnData.rawdata['budget_d'].push(budgetData.distributions[item.year])
        } else {
          returnData.rawdata['budget_d'].push(0)
        }
        if (budgetData && budgetData.capitalCalls && budgetData.capitalCalls[item.year]) {
          returnData.rawdata['budget_cc'].push(-budgetData.capitalCalls[item.year])
        } else {
          returnData.rawdata['budget_cc'].push(0)
        }
        //console.log('returnData.rawdata', returnData.rawdata)
      } else if (cashflowChartDisplay === 'Past') {

        returnData.rawdata['rcc'].push(rcc)
        returnData.rawdata['rd'].push(rd)
        returnData.rawdata['b'].push(rcc + rd)

        returnData.rawdata['mcc'].push(0)
        returnData.rawdata['md'].push(0)

      } else if (cashflowChartDisplay === 'All') {

        returnData.rawdata['rcc'].push(rcc)
        returnData.rawdata['rd'].push(rd)

        returnData.rawdata['mcc'].push((mcc - rcc < 0 ? mcc - rcc : 0))
        returnData.rawdata['md'].push((smd - rd > 0 ? smd - rd : 0))

        returnData.rawdata['b'].push(
          (-mcc > -rcc ? mcc : rcc)
          + (smd > rd ? smd : rd)
        )



      }
    }
  })
  //colmplete serie with budget
  if (cashflowChartDisplay !== 'Past' && showBudget && budgetData && budgetData.distributions && budgetData.distributions.length > 0) {
    budgetData.distributions.forEach((item, index) => {

      if (!returnData.categories.find((element) => element === index.toString())) {
        returnData.rawdata['budget_d'].push(item);
        returnData.rawdata['budget_cc'].push((budgetData.capitalCalls[index] ? -budgetData.capitalCalls[index] : 0));
        returnData.rawdata['rcc'].push(0);
        returnData.rawdata['rd'].push(0);
        returnData.rawdata['mcc'].push(0);
        returnData.rawdata['md'].push(0);

        returnData.categories.push(index.toString())
      }
    })

    returnData.rawdata['budget_d'].forEach((item, index) => {
      ////console.log('returnData.rawdata[budget_b]', index, returnData.rawdata['b'][index], returnData.rawdata['budget_b'][index])
      let full_balance = (returnData.rawdata['b'][index] ? returnData.rawdata['b'][index] : 0) + (returnData.rawdata['budget_d'][index] ? returnData.rawdata['budget_d'][index] : 0) + (returnData.rawdata['budget_cc'][index] ? returnData.rawdata['budget_cc'][index] : 0)
      returnData.rawdata['budget_b'].push(full_balance);

    })


  }

  returnData.data = []

  let backgroundColors = []
  let strokeWith = []
  let strokeColors = []

  if (!showBudget) {
    if (cashflowChartDisplay === 'Future') {
      backgroundColors.push(Variables.colorScheme.expected_neutral)
      backgroundColors.push(Variables.colorScheme.expected_neutral)
      backgroundColors.push(Variables.colorScheme.dark)
      strokeWith = [0, 0, 0]
      strokeColors = [Variables.colorScheme.expected_neutral, Variables.colorScheme.expected_neutral, Variables.colorScheme.dark]

    } else if (cashflowChartDisplay === 'Past') {
      backgroundColors.push(Variables.colorScheme.danger)
      backgroundColors.push(Variables.colorScheme.success)
      backgroundColors.push(Variables.colorScheme.dark)
      strokeColors = [Variables.colorScheme.danger, Variables.colorScheme.success, Variables.colorScheme.dark]
      strokeWith = [0, 0, 0]
    } else if (!showBudget) {
      backgroundColors.push(Variables.colorScheme.danger)
      backgroundColors.push(Variables.colorScheme.success)
      backgroundColors.push(Variables.colorScheme.expected_neutral)
      backgroundColors.push(Variables.colorScheme.expected_neutral)
      backgroundColors.push(Variables.colorScheme.dark)
      strokeColors = [Variables.colorScheme.danger, Variables.colorScheme.success, Variables.colorScheme.expected_neutral, Variables.colorScheme.expected_neutral, Variables.colorScheme.dark]
      strokeWith = [0, 0, 0, 0, 1]
    }
  } else {
    //console.log('showBudget', returnData.rawdata['budget_d'])
    // replace Balance (add budget)
    let new_balance = []
    returnData.categories.forEach((item, index) => {
      new_balance.push((returnData.rawdata['b'][index] ? returnData.rawdata['b'][index] : 0) + returnData.rawdata['budget_d'][index] + returnData.rawdata['budget_cc'][index])
    })
    returnData.rawdata['b'] = new_balance


  }

  if (cashflowChartDisplay !== 'Future') {
    returnData.data.push(
      {
        name: 'Actual Capital Call',
        type: 'column',
        data: returnData.rawdata['rcc'],

      },
      {
        name: 'Actual distribution',
        type: 'column',
        data: returnData.rawdata['rd']
      })
  }
  if (cashflowChartDisplay !== 'Past') {
    returnData.data.push({
      name: 'Expected Capital Call',
      type: 'column',
      data: returnData.rawdata['mcc'],
    },

      {
        name: 'Expected distribution',
        type: 'column',
        data: returnData.rawdata['md']
      },

    )

    if (showBudget) {
      returnData.data.push({
        name: 'Budget Capital Call',
        type: 'column',
        data: returnData.rawdata['budget_cc'],
      },

        {
          name: 'Budget distribution',
          type: 'column',
          data: returnData.rawdata['budget_d']
        },

      )

      backgroundColors.push(Variables.colorScheme.expected_neutral)
      backgroundColors.push(Variables.colorScheme.expected_neutral)
      backgroundColors.push(Variables.colorScheme.main_backgroundColor)
      backgroundColors.push(Variables.colorScheme.main_backgroundColor)
      backgroundColors.push(Variables.colorScheme.dark)
      strokeWith = [1, 1, 2, 2, 1]
      strokeColors = [Variables.colorScheme.expected_neutral, Variables.colorScheme.expected_neutral, Variables.colorScheme.expected_neutral, Variables.colorScheme.expected_neutral]

    }
  }
  //returnData.data.push({ name: 'Balance', type: 'column', data: returnData.rawdata['b'] });


  returnData.options = {
    colors: backgroundColors

    ,
    xaxis: {
      type: 'category',
      categories: returnData.categories,
      convertedCatToNumeric: false,

    },
    markers: {
      size: 4,
      strokeWidth: 1,
      colors: Variables.colorScheme.dark
    },

    stroke: {
      curve: 'smooth',

      colors: strokeColors,
      width: strokeWith
    }
  };

  returnData.options.annotations = {
    yaxis: [
      {
        y: 0,
        borderColor: Variables.colorScheme.dark,
      }
    ],
    points:
      returnData.categories.map(function (item, index) {
        return {
          id: 'balance' + index,
          x: returnData.categories[index],
          y: returnData.rawdata['b'][index],
          marker: {
            size: 3,
            style: 'rectangle',
            fillColor: Variables.colorScheme.dark,
          },
          label: {
            style: {
              color: (MoondanceLayout.is_dark_mode ? '#E6E8EC' : '#000000'),
              background: (MoondanceLayout.is_dark_mode ? '#2A3140' : '#FFFFFF'),
            },
            text: (scale === "cash" || scale === "cash_asset_currency" ? Math.round(returnData.rawdata['b'][index] / 1000) + ' k ' + (scale === "cash" ? MoondanceLayout.userCurrency : data.summary.asset_currency) : MoondanceLayout.formatPercentage(returnData.rawdata['b'][index])),
          }
        }
      })

  };
  //console.log('returnData annotations',showBudget, returnData.rawdata['b'],returnData.options.annotations)
  //console.log('returnData',returnData)
  return returnData
},
buildCumulatedCashFlowChart(data, cashflowChartDisplay, showCapitalCallsOnly = false, showBudget = false, scale = "cash") {
  var returnData = {}
  returnData.categories = [];

  returnData = {}

  returnData.categories = [];
  returnData.rawdata = [];
  returnData.rawdata['real'] = [];
  returnData.rawdata['expected'] = [];
  returnData.rawdata['real_aggr'] = [];
  returnData.rawdata['rb'] = [];

  returnData.rawdata['budget_balance'] = [];
  var cumulatedCall = 0;
  var cumulatedDist = 0;
  var cumulBudget = 0;
  var budgetData = []

  //console.log('scale', scale)

  if (showBudget && data.budget) {
    budgetData = MoondanceLayout.calculateBudget(data.budget)
    //console.log('budgetData', budgetData)
  }

  //remove trailing empty values
  while (data.perYear.length > 0) {
    let lastItem = data.perYear[data.perYear.length - 1];
    if (lastItem.sum_real_capital_call_in_user_currency === 0 &&
      lastItem.sum_model_capital_call_in_user_currency === 0 &&
      lastItem.sum_model_distribution_in_user_currency === 0 &&
      lastItem.sum_real_distribution_in_user_currency === 0) {
      data.perYear.pop(); // Remove last item
    } else {
      break; // Break out of the loop once a non-zero item is found
    }
  }
  data.perYear.forEach((item, index) => {

    let rcc = item.sum_real_capital_call_in_user_currency;
    let rd = item.sum_real_distribution_in_user_currency;
    let mcc = item.sum_model_capital_call_in_user_currency;
    let smd = item.sum_model_distribution_in_user_currency;
    let srcc = item.sum_real_capital_call_in_user_currency
    let srd = item.sum_real_distribution_in_user_currency
    let srb = item.sum_remaining_balance_in_user_currency


    if (scale === "cash_asset_currency") {

      rcc = item.sum_real_capital_call_in_asset_currency;
      rd = item.sum_real_distribution_in_asset_currency;
      mcc = item.sum_model_capital_call_in_asset_currency;
      smd = item.sum_model_distribution_in_asset_currency;
      srcc = item.sum_real_capital_call_in_asset_currency
      srd = item.sum_real_distribution_in_asset_currency
      srb = item.sum_remaining_balance_in_asset_currency

    } else if (scale === "pct_commited") {
      rcc = item.sum_real_capital_call_in_asset_currency / data.summary.position_commitment_in_asset_currency;
      rd = item.sum_real_distribution_in_asset_currency / data.summary.position_commitment_in_asset_currency;
      mcc = item.sum_model_capital_call_in_asset_currency / data.summary.position_commitment_in_asset_currency;
      smd = item.sum_model_distribution_in_asset_currency / data.summary.position_commitment_in_asset_currency;
      srcc = item.sum_real_capital_call_in_asset_currency / data.summary.position_commitment_in_asset_currency
      srd = item.sum_real_distribution_in_asset_currency / data.summary.position_commitment_in_asset_currency
      srb = item.sum_remaining_balance_in_asset_currency / data.summary.position_commitment_in_asset_currency
    } else if (scale === "pct_called") {

      rcc = item.sum_real_capital_call_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency;
      rd = item.sum_real_distribution_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency;
      mcc = item.sum_model_capital_call_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency;
      smd = item.sum_model_distribution_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency;
      srcc = item.sum_real_capital_call_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency
      srd = item.sum_real_distribution_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency
      srb = item.sum_remaining_balance_in_asset_currency / -data.summary.position_real_capital_call_in_asset_currency
    }


    if (item.year > 0 && item.year < new Date().getFullYear()) {
      if (cashflowChartDisplay !== 'Future') {
        returnData.categories.push(item.year.toString())
        cumulatedCall = cumulatedCall + srcc
        cumulatedDist = cumulatedDist + srd
        returnData.rawdata['real'].push(srcc + srd)
        returnData.rawdata['expected'].push(0)
        returnData.rawdata['budget_balance'].push(0)
      }

    } else if (item.year > new Date().getFullYear()) {


      if (cashflowChartDisplay === 'Future' && showCapitalCallsOnly) {

        returnData.categories.push(item.year.toString())
        cumulatedCall = cumulatedCall + srcc + mcc
        cumulatedDist = 0

        returnData.rawdata['real'].push(0)
        returnData.rawdata['expected'].push(mcc)


      } else if (cashflowChartDisplay !== 'Past') {

        returnData.categories.push(item.year.toString())
        cumulatedCall = cumulatedCall + srcc + mcc
        cumulatedDist = cumulatedDist + srd + smd
        if (showBudget && budgetData && budgetData.balance && budgetData.balance[item.year]) {
          cumulatedDist += budgetData.balance[item.year]
        }

        returnData.rawdata['real'].push(0)

        returnData.rawdata['expected'].push(
          mcc + smd
        )


      }
      if (cashflowChartDisplay !== 'Past' && showBudget && budgetData && budgetData.balance && budgetData.balance.length > 0) {
        returnData.rawdata['budget_balance'].push((budgetData.balance[item.year] ? budgetData.balance[item.year] : 0))
      }


    } else if (item.year === new Date().getFullYear()) {

      returnData.categories.push(item.year.toString())
      if (cashflowChartDisplay === 'Future') {
        cumulatedCall = cumulatedCall + srb

        if (showCapitalCallsOnly) {
          cumulatedDist = 0
          returnData.rawdata['expected'].push(srcc)

        } else {
          cumulatedDist = cumulatedDist + srb
          returnData.rawdata['expected'].push(srb)
          if (cashflowChartDisplay !== 'Past' && showBudget && budgetData && budgetData.balance && budgetData.balance.length > 0) {
            returnData.rawdata['budget_balance'].push((budgetData.balance[item.year] ? budgetData.balance[item.year] : 0))
          }
        }
        /*    returnData.rawdata['budget_cc'].push(-budgetData.capitalCalls[item.year])
                  } else {
                    returnData.rawdata['budget_cc'].push(0)
                  }*/


      } else if (cashflowChartDisplay === 'Past') {
        cumulatedCall = cumulatedCall + srcc
        cumulatedDist = cumulatedDist + srd
        returnData.rawdata['real'].push(srcc + srd)


      } else if (cashflowChartDisplay === 'All') {
        cumulatedCall = cumulatedCall + srcc
        cumulatedDist = cumulatedDist + srd
        returnData.rawdata['expected'].push(srb)
        returnData.rawdata['real'].push(srcc + srd)



        if (cashflowChartDisplay !== 'Past' && showBudget && budgetData && budgetData.balance && budgetData.balance.length > 0) {
          returnData.rawdata['budget_balance'].push((budgetData.balance[item.year] ? budgetData.balance[item.year] : 0))
        }
      }


    }

  })

  //console.log('budgetData', returnData.rawdata['budget_balance'])
  if (showBudget && budgetData && budgetData.balance && budgetData.balance.length > 0) {
    budgetData.balance.forEach((item, index) => {

      if (!returnData.categories.find((element) => element === index.toString())) {
        returnData.rawdata['real'].push(0)
        returnData.rawdata['expected'].push(0)

        returnData.rawdata['budget_balance'].push(budgetData.balance[index])
        returnData.categories.push(index.toString())

      }
    })
  }


  //complete serie with budget

  returnData.rawdata['real_aggr'] = []
  returnData.rawdata['budget_aggr'] = []


  //console.log('returnData.categories', returnData.categories)
  if (returnData.categories) {
    returnData.categories.forEach((item, index) => {

      let agg =
        (returnData.rawdata['real_aggr'][index - 1] ? returnData.rawdata['real_aggr'][index - 1] : 0)
        + (returnData.rawdata['real'][index] ? returnData.rawdata['real'][index] : 0)
        + (returnData.rawdata['expected'][index] ? returnData.rawdata['expected'][index] : 0)

      returnData.rawdata['real_aggr'].push(agg)


      if (showBudget && budgetData && budgetData.balance && budgetData.balance.length > 0) {
        let budget_aggr = (returnData.rawdata['budget_aggr'][index - 1] ? returnData.rawdata['budget_aggr'][index - 1] : 0)
        budget_aggr += (returnData.rawdata['real'][index] ? returnData.rawdata['real'][index] : 0)
        budget_aggr += (returnData.rawdata['expected'][index] ? returnData.rawdata['expected'][index] : 0)
        budget_aggr += (budgetData && budgetData.balance && budgetData.balance[parseInt(item)] ? budgetData.balance[parseInt(item)] : 0)

        returnData.rawdata['budget_aggr'].push(budget_aggr)

      }
    })
  }


  //
  //console.log('budget', budgetData)
  //complete years where therea are no real or expected data
  /*
  if (showBudget && budgetData && budgetData.balance && budgetData.balance.length > 0) {
    budgetData.balance.map((item, index) => {
      if (!returnData.categories.find((element) => element === index.toString())) {
        // console.log('BudgetData',item,index)
        returnData.rawdata['budget_balance'].push( parseFloat(budgetData.balance[index]))
        returnData.rawdata['real'].push(0)
        returnData.rawdata['expected'].push(0)
       
        
        returnData.categories.push(index.toString())
      }
    })
*/

  //  console.log('budget cumul', returnData.rawdata['budget'])

  returnData.data = [


    // Each series carries its own colour. The colour arrays below are DERIVED from
    // this list once the Past/Future filtering has run - they used to be written out
    // by hand and spliced in parallel, which drifted: with a budget there were five
    // series for four colours, the budgeted bars were painted in the page background
    // colour (invisible) and the last line got no colour at all.
    {
      name: 'Actual Annual Cashflow',
      type: 'column',
      data: returnData.rawdata['real'],
      color: Variables.colorScheme.actual_neutral,
    },
    {
      name: 'Expected Annual Cashflow',
      type: 'column',
      data: returnData.rawdata['expected'],
      color: Variables.colorScheme.expected_neutral,
    }
  ];

  const withBudget = !!(showBudget && budgetData);

  returnData.data.push(
    {
      // Named for what it excludes only when there is something to exclude.
      name: withBudget ? 'Cumulated Cashflow (excl. budget)' : 'Cumulated Cashflow',
      type: 'line',
      data: returnData.rawdata['real_aggr'],
      color: Variables.colorScheme.primary,
    });


  if (withBudget) {
    returnData.data.push({
      name: 'Budgeted Annual Cashflow',
      type: 'column',
      data: returnData.rawdata['budget_balance'],
      color: Variables.colorScheme.gold,
    });
    returnData.data.push({
      name: 'Cumulated Cashflow (incl. budget)',
      type: 'line',
      data: returnData.rawdata['budget_aggr'],
      color: Variables.colorScheme.dark,
    })
  }
  //console.log('returnData',showBudget, returnData.data)
  returnData.options = {
    xaxis: {
      type: 'category',
      categories: returnData.categories,
      // Must stay false: point annotations with a category string `x` do not
      // render in ApexCharts when convertedCatToNumeric is true.
      convertedCatToNumeric: false,

    },
    stroke: {
      curve: 'smooth',
    },
    tooltip: {
      y: {
        formatter: undefined,
        title: {
          formatter: (seriesName) => seriesName,
        },
      },

    }
  };

  // Drop the series the requested view does not show. Only `data` is spliced now;
  // everything colour-related is rebuilt from it afterwards, so the two can no
  // longer fall out of step.
  if (cashflowChartDisplay === 'Future') {
    returnData.data.splice(0, 1)   // no actuals in a forward-looking view
  }
  if (cashflowChartDisplay === 'Past') {
    returnData.data.splice(1, 1)   // no expectations in a backward-looking view
  }

  // Derived, never hand-maintained: one colour per remaining series, in order.
  // Lines are drawn thicker than the column outlines so the cumulated curves read
  // as curves rather than as bar borders.
  returnData.options.colors = returnData.data.map((s) => s.color);
  returnData.options.stroke.colors = returnData.data.map((s) => s.color);
  returnData.options.stroke.width = returnData.data.map((s) => (s.type === 'line' ? 3 : 1));
  returnData.options.markers = {
    size: 4,
    strokeWidth: 1,
    colors: returnData.data.map((s) => s.color),
    offsetX: 0,
  };

  // In "% of commitment" this chart IS a J-curve, so it is dressed like the one on
  // the dashboard: zero is the payback line, drawn dashed and named, and the
  // cumulative curve takes the colour of its outcome - green once the capital has
  // come back, brick red while it is still out. Brick and not the theme's danger
  // red: a curve below zero is where a young fund belongs, it is not an alert.
  const isPctScale = (scale === 'pct_commited' || scale === 'pct_called');
  const cumulativeSeries = returnData.data.find((s) => s.type === 'line');
  if (isPctScale && cumulativeSeries) {
    const points = (cumulativeSeries.data || []).filter((v) => v !== null && v !== undefined);
    const last = points.length ? points[points.length - 1] : 0;
    cumulativeSeries.color = last >= 0 ? Variables.colorScheme.primary : '#a35a4f';
    returnData.options.colors = returnData.data.map((s) => s.color || undefined);
  }

  // In the J-curve view a label on every point is unreadable: on this ten-year
  // position four of them overlapped in the flat stretch after the trough. Only the
  // points that carry the J-curve's story are named - where it starts, how deep it
  // digs, the year it crosses back over zero, and where it stands now. Every other
  // point keeps its marker and its tooltip, so nothing is hidden, only unwritten.
  const aggr = returnData.rawdata['real_aggr'] || [];
  let labelledPoints = null;
  if (isPctScale && aggr.length > 4) {
    const value = (i) => {
      const n = parseFloat(aggr[i]);
      return Number.isFinite(n) ? n : 0;
    };
    const keep = new Set([0, aggr.length - 1]);
    let trough = 0;
    aggr.forEach((v, i) => { if (value(i) < value(trough)) { trough = i; } });
    keep.add(trough);
    // The payback year: the first point back at or above zero after being under it.
    for (let i = 1; i < aggr.length; i++) {
      if (value(i - 1) < 0 && value(i) >= 0) { keep.add(i); break; }
    }
    labelledPoints = keep;
  }

  // Label each point of the cumulated balance line with its value.
  returnData.options.annotations = {
    yaxis: [
      {
        y: 0,
        borderColor: Variables.colorScheme.dark,
        strokeDashArray: isPctScale ? 4 : 0,
        // `label` must stay an OBJECT even when there is nothing to write. ApexCharts
        // merges each annotation over its defaults with a shallow extend, so a
        // `label: undefined` replaces the default label object instead of leaving it
        // alone - and the renderer then reads `anno.label.text` and throws, taking the
        // whole page down. An empty text is the way to say "no label".
        label: {
          text: isPctScale ? 'capital paid back' : '',
          position: 'left',
          textAnchor: 'start',
          borderWidth: 0,
          style: {
            color: (MoondanceLayout.is_dark_mode ? '#E6E8EC' : '#000000'),
            background: 'transparent',
            fontSize: '10px',
          },
        },
      }
    ],
    points:
      returnData.categories.map(function (item, index) {
        const balance = (returnData.rawdata['real_aggr'] ? returnData.rawdata['real_aggr'][index] : 0)
        return {
          id: 'cumbalance' + index,
          x: returnData.categories[index],
          y: balance,
          marker: {
            size: 3,
            style: 'rectangle',
            fillColor: Variables.colorScheme.dark,
          },
          label: {
            style: {
              color: (MoondanceLayout.is_dark_mode ? '#E6E8EC' : '#000000'),
              // An unwritten label must not leave its box behind.
              background: (labelledPoints && !labelledPoints.has(index)) ? 'transparent'
                : (MoondanceLayout.is_dark_mode ? '#2A3140' : '#FFFFFF'),
            },
            borderWidth: (labelledPoints && !labelledPoints.has(index)) ? 0 : 1,
            text: (labelledPoints && !labelledPoints.has(index)) ? ''
              : (scale === "cash" || scale === "cash_asset_currency" ? Math.round(balance / 1000) + ' k ' + (scale === "cash" ? MoondanceLayout.userCurrency : data.summary.asset_currency) : MoondanceLayout.formatPercentage(balance)),
          }
        }
      })
  };

  //console.log('buildCumulatedCashFlowChart', returnData)
  return returnData
},

buildOverviewChart(data, currency = false, useColor = true) {
  if (!data.summary) { return false }
  let commitment = 0
  let capitalCall = 0
  let distribution = 0
  let nav = 0
  let expected_callable = 0
  // console.log('currency',currency)

  //Fix for  dashboard values 
  if (data.summary && !data.summary.position_commitment_in_user_currency && data.summary.total_commited_in_user_currency) {
    data.summary.position_commitment_in_user_currency = data.summary.total_commited_in_user_currency
  }
  if (data.summary && !data.summary.position_real_capital_call_in_user_currency && data.summary.total_capital_call_in_user_currency) {
    data.summary.position_real_capital_call_in_user_currency = -data.summary.total_capital_call_in_user_currency
  }
  if (data.summary && !data.summary.position_real_distribution_in_user_currency && data.summary.total_distributed_in_user_currency) {
    data.summary.position_real_distribution_in_user_currency = data.summary.total_distributed_in_user_currency
  }
  if (data.summary && !data.summary.position_nav_in_user_currency_current_rate && data.summary.total_nav_in_user_currency_current_rate) {
    data.summary.position_nav_in_user_currency_current_rate = data.summary.total_nav_in_user_currency_current_rate
  }

  if (currency !== 'asset_currency') {
    commitment = data.summary.position_commitment_in_user_currency
    expected_callable = data.summary.total_expected_remaining_in_user_currency
    capitalCall = data.summary.position_real_capital_call_in_user_currency
    distribution = data.summary.position_real_distribution_in_user_currency
    nav = data.summary.position_nav_in_user_currency_current_rate
  } else {
    commitment = data.summary.position_commitment_in_asset_currency
    expected_callable = data.summary.position_expected_remaining_callable_capital_in_user_currency


    capitalCall = data.summary.position_real_capital_call_in_asset_currency
    distribution = data.summary.position_real_distribution_in_asset_currency
    nav = data.summary.position_nav_in_asset_currency
  }
  var returnData = {}
  returnData.data = [];

  //console.log('waterfall',data)
  // -Math.round(data.summary.total_capital_call_in_user_currency/1000,2)


  returnData.data.push(
    {
      x: 'Commitment',
      y: [0, Math.round(commitment / 1000, 2)],
      fillColor: (useColor ? Variables.colorScheme.gray : Variables.printColorScheme.main_backgroundColor),
      strokeColor: Variables.colorScheme.dark,
      strokeWidth: 0,
      value: Math.round(commitment / 1000, 2),


    }
  );

  returnData.data.push(
    {
      x: 'Called',
      y: [0, -Math.round(capitalCall / 1000, 2)],
      strokeColor: Variables.colorScheme.dark,
      fillColor: (useColor ? Variables.colorScheme.dark : Variables.printColorScheme.dark),
      strokeWidth: 0,
      value: -Math.round(capitalCall / 1000, 2),

    }
  );

  returnData.data.push(
    {
      x: 'Value Creation',
      y: [
        Math.round(-capitalCall / 1000, 2),
        Math.round((
          -capitalCall
          + distribution
          + nav + capitalCall) / 1000, 2)
      ],

      strokeColor: Variables.colorScheme.dark,
      fillColor: (capitalCall + distribution + nav > 0 ? (useColor ? Variables.colorScheme.success : Variables.printColorScheme.success) : (useColor ? Variables.colorScheme.danger : Variables.printColorScheme.danger)),
      strokeWidth: 0,
      value: Math.round((capitalCall + distribution + nav) / 1000, 2),
    },
  );

  returnData.data.push(
    {
      x: 'Distributed',
      y: [Math.round((
        - capitalCall
        + nav + capitalCall) / 1000, 2),
      Math.round((
        - capitalCall
        + distribution
        + nav + capitalCall) / 1000, 2)
      ],

      strokeColor: (useColor ? Variables.colorScheme.success : Variables.printColorScheme.success),
      strokeWidth: 6,
      fillColor: (useColor ? Variables.colorScheme.gray : Variables.printColorScheme.main_backgroundColor),

      value: -Math.round(distribution / 1000, 2),

    },
  );

  returnData.data.push(
    {
      x: 'NAV',
      y: [
        0, Math.round(nav / 1000, 2)
      ],
      strokeColor: Variables.colorScheme.dark,

      fillColor: (useColor ? Variables.colorScheme.gray : Variables.printColorScheme.main_backgroundColor),
      value: Math.round(nav / 1000, 2),
    },
  );


  returnData.options = {
    xaxis: {
      categories: ['Capital Called', 'Distributed', 'NAV', 'Gain & Losses'],

      type: 'category',
      convertedCatToNumeric: false,
    },
    yaxis: {
      //  min: -(parseInt(data.summary.position_commitment_in_user_currency / 100000) + 1) * 100000,
      //  max: (capitalCall + distribution + data.summary.position_nav_in_user_currency_current_rate > 0 ? (parseInt((data.summary.position_real_capital_call_in_user_currency + data.summary.position_real_distribution_in_user_currency + data.summary.position_nav_in_user_currency_current_rate) / 10000) + 1) * 10000 : 0),
    },

  };
  // console.log('buildOverviewChart', returnData)
  return returnData


},
buildCallableChart(data) {

  if (!data.summary) { return false }
  //Fix for  dashboard values 
  if (data.summary && !data.summary.position_commitment_in_user_currency && data.summary.total_commited_in_user_currency) {
    data.summary.position_commitment_in_user_currency = parseInt(data.summary.total_commited_in_user_currency)
  }
  if (data.summary && !data.summary.position_real_capital_call_in_user_currency && data.summary.total_capital_call_in_user_currency) {
    data.summary.position_real_capital_call_in_user_currency = parseInt(data.summary.total_capital_call_in_user_currency)
  }
  if (data.summary && !data.summary.position_real_distribution_in_user_currency && data.summary.total_distributed_in_user_currency) {
    data.summary.position_real_distribution_in_user_currency = parseInt(data.summary.total_distributed_in_user_currency)
  }



  var callable = {}

  callable.data = [
    {
      x: 'Commitment',
      y: [0, -data.summary.position_commitment_in_user_currency],
      fillColor: Variables.colorScheme.gray,
      value: -data.summary.position_commitment_in_user_currency,
    }]
  callable.data.push(
    {
      x: 'Called', y: [
        - data.summary.position_commitment_in_user_currency,
        -data.summary.position_commitment_in_user_currency - data.summary.position_real_capital_call_in_user_currency,
      ],
      fillColor: Variables.colorScheme.gray,
      value: -data.summary.position_real_capital_call_in_user_currency,
    },
  );
  callable.data.push(
    {
      x: 'Open Commitment',
      y: [
        0,
        -data.summary.position_commitment_in_user_currency - data.summary.position_real_capital_call_in_user_currency,
      ],
      fillColor: '#ff3d60',
      value: -data.summary.position_commitment_in_user_currency - data.summary.position_real_capital_call_in_user_currency,
    },
  );

  callable.options = {
    xaxis: {
      categories: ['Commitment', 'Called', 'Open Commitment'],
    },
    yaxis: {
      min: -(parseInt(data.summary.position_commitment_in_user_currency / 100000) + 1) * 100000,
      max: (data.summary.position_real_capital_call_in_user_currency + data.summary.position_real_distribution_in_user_currency + data.summary.position_nav_in_user_currency_current_rate > 0 ? (parseInt((data.summary.position_real_capital_call_in_user_currency + data.summary.position_real_distribution_in_user_currency + data.summary.position_nav_in_user_currency_current_rate) / 10000) + 1) * 10000 : 0),
    },

  };

  //console.log('buildCallableChart', callable);
  return callable;

},

sumArrays(array1, array2) {
  const maxLength = Math.max(array1.length, array2.length);
  const result = [];

  for (let i = 0; i < maxLength; i++) {
    // Use || to substitute 0 where a value is undefined
    const value1 = array1[i] || 0;
    const value2 = array2[i] || 0;
    result.push(value1 + value2);
  }

  return result;
},

isDate(variable) {
  return variable instanceof Date;
},
dateStringToTimestamp(dateStr) {
  // Assuming dateStr is in DD/MM/YYYY format
  const parts = dateStr.split('/');
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // JavaScript months are 0-indexed
  const year = parseInt(parts[2], 10);

  // Create a date object with year, month, and day
  const date = new Date(year, month, day);
  // console.log('dateStringToTimestamp', date, date.getTime())
  // Return the timestamp (number of milliseconds since the Unix Epoch)
  return date.getTime() / 1000;
},
timestampToDateString(timestamp) {
  // Assuming the timestamp is in milliseconds
  const date = new Date(timestamp * 1000);
  // Use the browser's locale to determine the date format
  return new Intl.DateTimeFormat(navigator.language, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(date);
},

chartOptionTimelineChart(data, xaxis, yaxis, output) {
  const chartData = data.map(item => {
    return {
      x: item[xaxis], // Assuming the date is in a format ApexCharts can understand
      y: item[yaxis]
    };
  });
  //console.log('chartOptionTimelineChart', chartData)
  const chartOptions = {
    chart: {
      type: 'line'
    },/*
      xaxis: {
        type: 'category',
        categories: chartData.map(item => item.x),
      },
      yaxis: {
        title: {
          text: 'NAV in EUR'
        }
      },*/
  }
  const chartSeries = [{
    name: 'NAV in EUR',
    data: chartData
  }]
  if (output === 'options') {
    //console.log('chartOptionTimelineChart', chartOptions)
    return chartOptions
  } else {

    //console.log('chartOptionTimelineChart', chartSeries)
    return chartSeries
  }

},


findMatchingPositions(position_list, selected_position_id) {
  // Find the selected position object

  const selectedPosition = position_list.find(position => position.position_id === parseInt(selected_position_id));

  if (!selectedPosition) {
    // If the selected position is not found, return an empty array
    return [];
  }

  // Extract asset_name and asset_feeder_name from the selected position
  const { asset_name, asset_feeder_name } = selectedPosition;



  //console.log('findMatchingPositions', asset_name, asset_feeder_name)
  // Find other positions with the same asset_name or asset_feeder_name
  const matchingPositions = position_list.filter(position => {
    return (position.asset_name === asset_name || (position.asset_feeder_name !== 'undefined' && position.asset_feeder_name !== '' && position.asset_feeder_name === asset_feeder_name)) && parseInt(position.position_id) != parseInt(selected_position_id);
  });
  //console.log('Matching positions found :', matchingPositions)
  return matchingPositions;
},

convertToDateString(input, formatType = '') {
  // Helper function to pad single-digit months/days with zero
  function padZero(value) {
    return value < 10 ? '0' + value : value;
  }

  // Helper function to format date as YYYY-MM-DD
  function formatDate(date) {
    const year = date.getFullYear();
    const month = padZero(date.getMonth() + 1); // Months are zero-indexed
    const day = padZero(date.getDate());
    return `${day}/${month}/${year}`;
  }

  // Handle Excel timestamp if formatType is 'xls'
  if (formatType === 'xls') {
    if (typeof input === 'number') {
      // Excel timestamps start from Jan 1, 1900
      const excelEpoch = new Date(Date.UTC(1899, 11, 30)); // Excel treats 1900-01-01 as day 1, with an extra leap year bug
      const date = new Date(excelEpoch.getTime() + input * 86400000); // Multiply input by milliseconds per day
      return formatDate(date);
    }
    return false;
  }

  // If input is an integer, assume it's a timestamp
  if (Number.isInteger(input)) {
    const date = input.toString().length === 13 ? new Date(input) : new Date(input * 1000);
    return formatDate(date);
  }

  // If input is a string, check if it's a valid date string
  if (typeof input === 'string' && !isNaN(Date.parse(input))) {
    const date = new Date(input);
    return formatDate(date);
  }

  // If input is neither a valid integer nor a date string, return an error message
  return 'Invalid input. Cannot convert to date.';
},
calculateBudget(budget) {

  let capitalCalls = [];
  let distributions = [];
  let balance = [];
  let investments = [];
  let commitment = [];
  let cumulativeBalance = [];
  let cumulativeCalls = [];
  let already_commited = [];

  //console.log('calculateBudget', budget)
  // Initialize investments for each year

  Object.entries(budget).forEach(([accountId, accountBudget]) => {
    //console.log('accountBudget', accountBudget)
    accountBudget.forEach(accountBudget => {

      for (let yearCount = 0; yearCount < accountBudget.invest_period; yearCount++) {
        investments.push({
          accountId: accountId,
          already_commited: (yearCount == 0 ? accountBudget.already_commited : 0),
          commited: (yearCount == 0 ? accountBudget.remaining_budget : 0),
          amount: accountBudget.remaining_budget / accountBudget.invest_period,
          startYear: accountBudget.year + yearCount,
          detentionPeriod: accountBudget.detention_period,
          irr: accountBudget.expected_irr
        });
      }
    })
  });
  // console.log('investments', investments)

  let maxYear = Math.max(...investments.map(item => item.startYear)) + Math.max(...investments.map(item => item.detentionPeriod))
  //console.log('max year', maxYear)
  let startYear = MoondanceLayout.currentYear()

  // Calculate capital calls and distributions
  for (let year = startYear; year <= maxYear; year++) {
    let yearIndex = year;
    capitalCalls[yearIndex] = 0;
    distributions[yearIndex] = 0;
    commitment[yearIndex] = 0;
    already_commited[yearIndex] = 0;


    //Commitment

    investments.forEach(investment => {
      if (investment.startYear === year) {
        commitment[yearIndex] += parseInt(investment.commited)
        already_commited[yearIndex] += parseInt(investment.already_commited)
      }
    });


    // Capital Calls
    investments.forEach(investment => {
      if (investment.startYear === year) {
        capitalCalls[yearIndex] += parseInt((investment.amount ? investment.amount : 0))
      }
    });

    // Distributions
    investments.forEach(investment => {
      if (year - investment.startYear === investment.detentionPeriod) {
        let compoundedAmount = (investment.amount ? investment.amount * Math.pow(1 + investment.irr, investment.detentionPeriod) : 0);
        let distribution = compoundedAmount;

        distributions[yearIndex] += parseInt(distribution)

      }
    });
    // Distributions
    balance[yearIndex] = (balance[yearIndex] ? balance[yearIndex] : 0) + (distributions[yearIndex] ? distributions[yearIndex] : 0) - (capitalCalls[yearIndex] ? capitalCalls[yearIndex] : 0)

    cumulativeBalance[yearIndex] = (cumulativeBalance[yearIndex - 1] ? cumulativeBalance[yearIndex - 1] : 0) + (balance[yearIndex] ? balance[yearIndex] : 0)
    cumulativeCalls[yearIndex] = (cumulativeCalls[yearIndex - 1] ? cumulativeCalls[yearIndex - 1] : 0) - (capitalCalls[yearIndex] ? capitalCalls[yearIndex] : 0)
  }
  return { capitalCalls, distributions, balance, cumulativeBalance, cumulativeCalls, commitment, already_commited };
},

filterDataPeryear(dataArray) {
  const currentYear = new Date().getFullYear();

  dataArray.forEach((item, index) => {

    if (item.year === 0) {
      dataArray.splice(index, 1);
    }


    if (item.year > 0 && item.year < currentYear) {
      item['sum_remaining_capital_call_in_user_currency'] = 0;
      item['sum_remaining_distribution_in_user_currency'] = 0;
      item['sum_remaining_balance_in_user_currency'] = 0;
      item['cumul_model_balance_in_user_currency'] = 0;

      Object.keys(item).forEach(key => {
        if (key.includes("model")) {
          item[key] = 0;
        }
      });

    } else if (item.year > 0 && item.year >= currentYear) {
      item['sum_remaining_capital_call_in_user_currency'] = (item['sum_model_capital_call_in_user_currency'] - item['sum_real_capital_call_in_user_currency'] < 0 ? item['sum_model_capital_call_in_user_currency'] - item['sum_real_capital_call_in_user_currency'] : 0);
      item['sum_remaining_distribution_in_user_currency'] = (item['sum_model_distribution_in_user_currency'] - item['sum_real_distribution_in_user_currency'] > 0 ? item['sum_model_distribution_in_user_currency'] - item['sum_real_distribution_in_user_currency'] : 0);
      item['sum_remaining_balance_in_user_currency'] = item['sum_remaining_capital_call_in_user_currency'] + item['sum_remaining_distribution_in_user_currency'];

    }



    if (item.year < currentYear) {
      item['cumul_actual_balance_in_user_currency'] = (dataArray[index - 1] && dataArray[index - 1]['cumul_actual_balance_in_user_currency'] ? dataArray[index - 1]['cumul_actual_balance_in_user_currency'] + item['sum_real_balance_in_user_currency'] : item['sum_real_balance_in_user_currency'])
      item['balance_in_user_currency'] = item['sum_real_balance_in_user_currency']
      item['cumul_model_balance_in_user_currency'] = 0

      item['cumul_balance_in_user_currency'] = item['cumul_actual_balance_in_user_currency']

    } else if (item.year == currentYear) {
      item['cumul_actual_balance_in_user_currency'] = (dataArray[index - 1] && dataArray[index - 1]['cumul_actual_balance_in_user_currency'] ? dataArray[index - 1]['cumul_actual_balance_in_user_currency'] + item['sum_real_balance_in_user_currency'] : item['sum_real_balance_in_user_currency'])
      item['cumul_model_balance_in_user_currency'] = (dataArray[index - 1] && dataArray[index - 1]['cumul_model_balance_in_user_currency'] ? dataArray[index - 1]['cumul_model_balance_in_user_currency'] + item['sum_remaining_balance_in_user_currency'] : item['sum_remaining_balance_in_user_currency'])

      item['balance_in_user_currency'] = item['sum_real_balance_in_user_currency'] + item['sum_remaining_balance_in_user_currency']

      item['cumul_balance_in_user_currency'] = item['cumul_actual_balance_in_user_currency'] + item['sum_remaining_balance_in_user_currency']


    } else {
      item['cumul_model_balance_in_user_currency'] = (dataArray[index - 1] && dataArray[index - 1]['cumul_model_balance_in_user_currency'] ? dataArray[index - 1]['cumul_model_balance_in_user_currency'] + item['sum_remaining_balance_in_user_currency'] : item['sum_remaining_balance_in_user_currency'])
      item['balance_in_user_currency'] = item['sum_remaining_balance_in_user_currency']
      item['cumul_balance_in_user_currency'] = (dataArray[index - 1] && dataArray[index - 1]['cumul_balance_in_user_currency'] ? dataArray[index - 1]['cumul_balance_in_user_currency'] + item['sum_remaining_balance_in_user_currency'] : item['sum_remaining_balance_in_user_currency'])

    }

  });



  return dataArray

},
// Helper function to validate value type
isValidType(value, expectedType) {
  switch (expectedType) {
    case "string":
      return typeof value === "string";

    case "number":
    case "float": // Treat 'float' the same as 'number'
      return !isNaN(value) && !isNaN(parseFloat(value));

    case "int":
    case "integer":
      return Number.isInteger(Number(value));

    case "boolean":
      return typeof value === "boolean";

    case "object":
      return typeof value === "object" && value !== null;

    case "array":
      return Array.isArray(value);

    case "date":
      return value instanceof Date || (!isNaN(Date.parse(value)));

    case "dateString":
      return this.isValidDateString(value);

    default:
      console.warn(`Unknown type '${expectedType}' for validation.`);
      return true; // Assume valid if type is unknown
  }
},

// Helper function to validate "dateString" format (dd/mm/yyyy OR yyyy-mm-dd)
isValidDateString(value) {
  if (typeof value !== "string") return false;

  // Regex for 'dd/mm/yyyy' format
  const ddmmyyyyRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

  // Regex for 'yyyy-mm-dd' format
  const yyyymmddRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;

  return ddmmyyyyRegex.test(value) || yyyymmddRegex.test(value);
}



}
function distributePercentages(years, quartile) {
  const positions = {
    1: (years + 1) / 4,
    2: 2 * (years + 1) / 4,
    3: 3 * (years + 1) / 4
  };
  const mean = positions[quartile];  // Adjust mean to the selected quartile
  const stdDev = years / 6;          // Standard deviation, controls the spread

  // Calculate normal distribution density
  function normalDensity(x) {
    return Math.exp(-0.5 * Math.pow((x - mean) / stdDev, 2)) / (stdDev * Math.sqrt(2 * Math.PI));
  }

  // Calculate densities for each year
  let densities = [];
  for (let i = 0; i < years; i++) {
    densities.push(normalDensity(i));
  }

  // Normalize densities to get percentages that sum to 1 (or 100%)
  const sumDensities = densities.reduce((a, b) => a + b, 0);
  let percentages = densities.map(d => (d / sumDensities) * 100);

  // Round to two decimal places and adjust to ensure sum is exactly 100%
  percentages = percentages.map(p => Math.round(p * 100) / 100);
  const error = 100 - percentages.reduce((a, b) => a + b, 0);
  percentages[percentages.length - 1] += error;  // Adjust the last element by the rounding error

  return percentages;

}


export default MoondanceLayout;